import { computed, inject, Injectable, signal } from '@angular/core';
import { VolunteerSignupSpecialistWithAllTopics } from '@interfaces';
import { AppService, FuncService } from "../../../../../services";

@Injectable({
	providedIn: 'root'
})
export class SpecialistSignUpViewerDialogDataService {

	private app = inject(AppService);
	private func = inject(FuncService);
	specialistSignUpDetails = signal<VolunteerSignupSpecialistWithAllTopics | undefined>(undefined);

	public canEdit = computed(() => this.app.data().permissions.canCoordinateVolunteers);

	public async getVolunteerSignupSpecialistData(volunteerSignupSpecialistId: number) {
		const response = await this.func.volunteering.specialistSignUp.getSpecialistSignup({ volunteerSignupSpecialistId });
		if (response) this.specialistSignUpDetails.set(response);
	}

}